import { client, type ClientId } from '@atlassian/rovo-content-bridge-api/client-types';

export const JSM_CREATE_SURVEY_CLIENT_ID: ClientId = client('jsm-create-survey');
